// page init
jQuery(function(){
	initTabs();
	initPopups();
	initCheckedClasses();
	
	$('.libr-calendar-block').pickmeup({
		flat		: true,
		mode		: 'range',
		calendars	: 2
	});
	
	jQuery('.libr-textarea-scrollbar').scrollbar();
	
	$(window).resize(function (){
       var top = ($(window).height() - $('.libr-lightbox').outerHeight())/2;
            top = top  < 20 ? 20 : top;
			$('.libr-lightbox').css({
            top:top
        });
    });
    $(window).resize();

});

// content tabs init
function initTabs() {
	jQuery('ul.libr-tabset').contentTabs({
		tabLinks: 'a'
	});
}

// popups init
function initPopups() {
	jQuery('.libr-popup-holder').contentPopup({
		popup: '.libr-popup',
		btnOpen: '.libr-open',
		mode: 'click'
	});
}